export interface CrmId {
  customerNumber: string;
  subsidiaryCode: string;
}
